export const SET_DADOS_ON_BOARD = 'SET_DADOS_ON_BOARD';